import { render, staticRenderFns } from "./GPhoneForm.vue?vue&type=template&id=7a81b79e&"
import script from "./GPhoneForm.vue?vue&type=script&lang=ts&"
export * from "./GPhoneForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports